import { ThemeUICSSObject, ThemeUIStyleObject } from '@apia/theme';
import administration from './administration';
import execution from './execution';
import login from './login';
import query from './query';
import templates from './templates';
import monitor from './monitor';
import control from './control';
import test from './test';
import main from './main';
import views from './views';
import stylesObject from '../stylesObject';
import common from './common';
import design from './design';
import ai from './ai';
/* IMPORT HERE */

export type TStylesObject =
  | (() => ThemeUICSSObject)
  | Record<string, () => ThemeUICSSObject>
  | Record<string, ThemeUICSSObject>
  | ThemeUICSSObject;

const layout: () => Record<string, ThemeUIStyleObject<any>> = () => {
  return {
    administration,
    common: common(),
    ...templates,
    execution,
    query,
    login,
    monitor,
    control,
    root: stylesObject(),
    test,
    main,
    views,
    design,
    ai,
    /* PREPEND HERE */
  };
};

export default layout;
